app.controller("VerifyPhoneController", ["$scope", "AuthService", "$state",
    function ($scope, AuthService, $state) {
        $scope.phone = AuthService.phone || localStorage.getItem('phone');
        $scope.userId = AuthService.userId || localStorage.getItem('userId');

        if (!$scope.userId) {
            AuthService.getPass().then(function (res) {
                $scope.phone = res.data.phone;
                $scope.userId = res.data.userId;
                localStorage.setItem('userId', res.data.userId);
                localStorage.setItem('phone', res.data.phone);
            });
        }

        $scope.submit = function () {
            $scope.status = '';
            if ($scope.phone && $scope.phone.length >= 9) {
                AuthService.verifyPhone({
                    phone: $scope.phone,
                    userId: $scope.userId
                }).then(function (res) {
                    if (res.sms === 'Success') {
                        AuthService.phone = $scope.phone;
                        $state.go('sms-auth')
                    }
                    if (res.err === 'No userId or Invalid phone') $state.go('login')
                    if (res.err === 'TIMEOUT') {
                        $scope.status = 'error';
                        $scope.errorText = 'სცადეთ მოგვიანებით';
                    }
                    if (res.err && res.err.ErrorCode === 75) {
                        $scope.status = 'error';
                        $scope.errorText = 'მითითებული ნომერი არ არსებობს';
                    }
                }).catch(function (err) {
                    console.error(err);
                })
            } else {
                $scope.status = 'error';
                $scope.errorText = 'გთხოვთ სწორად მიუთითოთ ტელეფონის ნომერი';
            }
        }
    }
]);
